module.exports = __webpack_public_path__ + "static/media/businessPlaceholder.a39fc423.svg";